import { PortfolioType } from '@/types/portfolio';

export const DEFAULT_NOTIONAL = 1_000_000;
export const DEFAULT_BASKET_NOTIONAL = 100_000_000;
export const DEFAULT_BASKET_DIVISOR = 1_000_000;

const portfolioTypeToDefaultNotional = {
  [PortfolioType.PORTFOLIO]: DEFAULT_NOTIONAL,
  [PortfolioType.CONSTITUENT]: DEFAULT_NOTIONAL,
  [PortfolioType.EQUITY_BASKET]: DEFAULT_BASKET_NOTIONAL,
  [PortfolioType.QIS_BASKET]: DEFAULT_BASKET_NOTIONAL,

  // TODO: Review if Peer Group should have a default notional set
  [PortfolioType.PEER_GROUP]: DEFAULT_NOTIONAL,
};

export const getDefaultNotionalForPortfolio = (treeType?: PortfolioType): number => {
  return treeType ? (portfolioTypeToDefaultNotional[treeType] ?? DEFAULT_NOTIONAL) : DEFAULT_NOTIONAL;
};
